import React, { useEffect, useState } from 'react';
import { filter, get, size } from 'lodash';

import Icons from '@/icons';
import { ICONS } from '@/constants/icons.constants';
import Slider from '../slider/Slider';
import { musicPlayerStore, songsStore } from '@/store';
import { BASE_URL, MEDIA_URL } from '@/axios';
import { generalHelpers, myMusicHelpers } from '@/helpers';

import styles from './MusicPlayer.module.scss';

const MusicPlayer = () => {
  const { music, setMusic } = musicPlayerStore();
  const { songs } = songsStore();

  const filteredSongsData = filter(songs, (item: any) => item.submission_status === 'ACCEPTED');

  const [sliderValue, setSliderValue] = useState(0);
  const [isMuted, setIsMuted] = React.useState(false);
  const [search, setSearch] = useState('');
  const [isChnage, setIsChange] = useState(false);
  const [isPlaying, setIsPlaying] = React.useState(false);

  const sliderRef = React.useRef<HTMLInputElement>(null);
  const audioRef1 = React.useRef<HTMLAudioElement>(null);
  const volumeBarRef = React.useRef<HTMLInputElement>(null);
  const volume = React.useRef(1);
  const audioChange = React.useRef(false);

  const handleTogglePlay = () => {
    if (audioRef1.current?.paused) {
      audioRef1.current?.play();
      setIsPlaying(true);
    } else {
      audioRef1.current?.pause();
      setIsPlaying(false);
    }
  };
  const handleSliderChange = (e: number) => {
    setSliderValue(e);
  };
  const handleNextSong = () => {
    audioChange.current = true;
    const currentSongIndex = filteredSongsData.findIndex((song) => song.id === music.id);
    if (currentSongIndex === filteredSongsData.length - 1) {
      setMusic(filteredSongsData[0]);
    } else {
      setMusic(filteredSongsData[currentSongIndex + 1]);
    }
  };

  const handlePreviousSong = () => {
    audioChange.current = true;
    const currentSongIndex = filteredSongsData.findIndex((song) => song.id === music.id);
    if (currentSongIndex === 0) {
      setMusic(filteredSongsData[filteredSongsData.length - 1]);
    } else {
      setMusic(filteredSongsData[currentSongIndex - 1]);
    }
  };

  useEffect(() => {
    audioRef1.current?.addEventListener('timeupdate', () => {
      const currentTime = audioRef1.current?.currentTime || 0;
      const duration = audioRef1.current?.duration || 0;

      const percentage = (currentTime / duration) * 100;
      const percentageToSet = isNaN(percentage) ? 0 : percentage;

      handleSliderChange(percentageToSet);
    });

    audioRef1.current?.addEventListener('ended', () => {
      audioRef1.current?.pause();
    });
  }, []);

  // useEffect(() => {
  //   if (audioChange.current) {
  //     audioRef1.current?.load();
  //     audioRef1.current?.play();
  //     setIsPlaying(true);
  //     audioChange.current = false;
  //   }
  // }, [music]);

  useEffect(() => {
    const totalSong = myMusicHelpers.searchResult(songs, search);
    if (size(totalSong) > 0) {
      setMusic(totalSong[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [songs]);

  const sliderChange = (sliderValue: number) => {
    const duration = audioRef1.current?.duration || 0;

    const currentTime = (sliderValue / 100) * duration;

    audioRef1.current!.currentTime = currentTime;
  };

  return (
    <div className={styles.MusicPlayer}>
      <audio
        ref={audioRef1}
        src={`${BASE_URL}/media/${music.audio_track}`}
        style={{
          width: '100%',
          height: 50,
        }}
        onLoadedMetadata={() => {
          setIsChange((prev) => !prev);
        }}
      />
      <div className={styles.left}>
        <div className={styles.part1}>
          <div className={styles.imageContainer}>
            <img
              src={`${MEDIA_URL}/${music.thumbnail_img}`}
              alt="music image"
            />
          </div>
          <div className={styles.desc}>
            <h2 className={styles.title}>
              {get(music, 'title', '')}
              {/* <TextWithTooltip text={get(music, 'title', '')} /> */}
            </h2>
            <p className={styles.name}>{get(music, 'artist_name', '')}</p>
            <p className={styles.genr}>{get(music, 'genre')}</p>
          </div>
        </div>
        <div className={styles.part2}>
          <div className={styles.iconContainer}>
            <Icons type={ICONS.PREVIOUS} onClick={handlePreviousSong} />
            {isPlaying ? (
              <Icons type={ICONS.PAUSE_ICON} onClick={handleTogglePlay} />
            ) : (
              <Icons type={ICONS.PLAY} onClick={handleTogglePlay} />
            )}

            <Icons type={ICONS.NEXT} onClick={handleNextSong} />
          </div>
          <div className={styles.playerBox}>
            <p className={styles.startTime}>
              {audioRef1.current?.currentTime
                ? generalHelpers.convertTimeInToMinutesandSeconds(audioRef1.current?.currentTime)
                : '0:00'}
            </p>
            <div className={styles.progreessBar}>
              <Slider
                className={styles.slider}
                ref={sliderRef}
                color1="#6B3EB4"
                color2="#6B3EB4"
                value={sliderValue}
                onChange={sliderChange}
              />
            </div>
            <p className={styles.endTime}>
              {audioRef1.current?.duration
                ? generalHelpers.convertTimeInToMinutesandSeconds(audioRef1.current?.duration)
                : '0:00'}
            </p>
          </div>
        </div>
      </div>
      <div className={styles.part3}>
        <div className={styles.volume}>
          <div
            className={styles.VolumeIcon}
            onClick={() => {
              if (audioRef1.current) {
                audioRef1.current.muted = !isMuted;
              }
              setIsMuted((prev) => !prev);
            }}
          >
            {!isMuted ? <Icons type={ICONS.VOLUMEICON} /> : <Icons type={ICONS.MUTE} />}
          </div>
          <div className={styles.volumeBar}>
            <Slider
              color1="#6B3EB4"
              color2="#6B3EB4"
              className={styles.musicBar}
              ref={volumeBarRef}
              value={volume.current * 100}
              onChange={(e) => {
                if (audioRef1.current) {
                  audioRef1.current.volume = e / 100;
                }
                volume.current = e / 100;
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MusicPlayer;
